var _rect, _rect2, _path, _path2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_528_1160)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_528_1160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 32,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -4,
    width: 32,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_528_1160)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 0V24H28V0H-4Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_528_1160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 0V24H28V0H-4Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_528_1160)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_528_1160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 32,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -4,
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_528_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.56323 22.2854L-0.521543 25.2635L28.1597 3.23787L31.874 -1.18761L24.344 -2.18297L12.6456 7.3085L3.22956 13.7035L-7.56323 22.2854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.59924 24.3719L-3.01183 26.1002L30.5402 -1.59878H25.5031L-6.59924 24.3719Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5631 22.2854L24.5214 25.2635L-4.15982 3.23787L-7.87415 -1.18761L-0.344074 -2.18297L11.3543 7.3085L20.7703 13.7035L31.5631 22.2854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3229 23.7829L27.7355 25.5111L13.4487 13.6518L9.21293 12.3267L-8.23151 -1.17246H-3.19436L14.2403 12.0063L18.8713 13.5952L31.3229 23.7829Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-1_528_1160",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7777 -2H8.22215V8H-5.97253V16H8.22215V26H15.7777V16H30.0275V8H15.7777V-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7777 -2H8.22215V8H-5.97253V16H8.22215V26H15.7777V16H30.0275V8H15.7777V-2Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22215 -2V-3H7.22215V-2H8.22215ZM15.7777 -2H16.7777V-3H15.7777V-2ZM8.22215 8V9H9.22215V8H8.22215ZM-5.97253 8V7H-6.97253V8H-5.97253ZM-5.97253 16H-6.97253V17H-5.97253V16ZM8.22215 16H9.22215V15H8.22215V16ZM8.22215 26H7.22215V27H8.22215V26ZM15.7777 26V27H16.7777V26H15.7777ZM15.7777 16V15H14.7777V16H15.7777ZM30.0275 16V17H31.0275V16H30.0275ZM30.0275 8H31.0275V7H30.0275V8ZM15.7777 8H14.7777V9H15.7777V8ZM8.22215 -1H15.7777V-3H8.22215V-1ZM9.22215 8V-2H7.22215V8H9.22215ZM-5.97253 9H8.22215V7H-5.97253V9ZM-4.97253 16V8H-6.97253V16H-4.97253ZM8.22215 15H-5.97253V17H8.22215V15ZM9.22215 26V16H7.22215V26H9.22215ZM15.7777 25H8.22215V27H15.7777V25ZM14.7777 16V26H16.7777V16H14.7777ZM30.0275 15H15.7777V17H30.0275V15ZM29.0275 8V16H31.0275V8H29.0275ZM15.7777 9H30.0275V7H15.7777V9ZM14.7777 -2V8H16.7777V-2H14.7777Z",
    fill: "white",
    mask: "url(#path-10-inside-1_528_1160)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_528_1160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/United Kingdom.5b36f5069bb3cfaf865df1a8e9eb26d9.svg";
export { ForwardRef as ReactComponent };